<script setup>
  import { ref, watch } from "vue";
  import { storeToRefs } from "pinia";
  import { useTemplateStore } from "@stores/mailing/template";
  import { useEmailEditor } from "@composables/useEmailEditor";

  const templateStore = useTemplateStore();
  const { handleTemplateSave } = templateStore;
  const { template } = storeToRefs(templateStore);

  const editorFrame = ref(null);
  const editorUrl = import.meta.env.VITE_EMAIL_EDITOR_URL;

  const onTemplateSaved = (data) => {
    if (template.value && data.json && data.html) {
      template.value.json_content = data.json;
      template.value.html_content = data.html;
      handleTemplateSave();
    }
  };

  const { iframeReady, onIframeLoad, loadTemplate } = useEmailEditor({
    editorFrame,
    editorUrl,
    onTemplateSaved,
  });

  watch(
    iframeReady,
    (isReady) => {
      if (isReady && template.value?.json_content) {
        loadTemplate(template.value.json_content);
      }
    },
    { immediate: true },
  );
</script>

<template>
  <iframe
    ref="editorFrame"
    :src="editorUrl"
    title="Email Editor"
    class="sticky -m-5 block h-[calc(100vh-60px)] w-[calc(100%+2.5rem)] border-none"
    @load="onIframeLoad" />
</template>
